// third party imports
import PropTypes from 'prop-types';

import { TextField, Autocomplete } from '@mui/material';

const AutocompleteInput = ({
    dropdownData,
    id,
    name,
    value,
    onChange,
    multiSelect,
    onInputChange,
    inputValue,
    disableClearable = true,
    ...props
}) => (
    <Autocomplete
        id={id}
        name={id}
        disablePortal
        defaultValue={multiSelect ? [] : null}
        multiple={multiSelect}
        inputValue={inputValue}
        disableClearable={disableClearable}
        options={dropdownData}
        value={value}
        onChange={onChange}
        onInputChange={onInputChange}
        renderInput={(params) => <TextField {...props} {...params} label={name} />}
        {...props}
    />
);

export default AutocompleteInput;

AutocompleteInput.propTypes = {
    dropdownData: PropTypes.array,
    id: PropTypes.string,
    name: PropTypes.string,
    value: PropTypes.string,
    multiSelect: PropTypes.bool,
    disableClearable: PropTypes.bool,
    onChange: PropTypes.func
};
